import { useEffect, useState } from 'react';

const loaded = new Map<string, Promise<void>>();

const loadScript = (src: string): Promise<void> => {
	const cached = loaded.get(src);
	if (cached) return cached;

	const promise = new Promise<void>((resolve, reject) => {
		const existing = document.querySelector(`script[src="${src}"]`);
		if (existing) {
			resolve();
			return;
		}
		const tag = document.createElement('script');
		tag.src = src;
		tag.async = true;
		tag.onload = () => resolve();
		tag.onerror = () => reject(new Error(`Failed to load ${src}`));
		document.head.appendChild(tag);
	});

	loaded.set(src, promise);
	return promise;
};

export const useExternalScripts = (sources: string[]): { ready: boolean; error: Error | null } => {
	const [ready, setReady] = useState(false);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		let cancelled = false;
		Promise.all(sources.map(loadScript))
			.then(() => {
				if (!cancelled) setReady(true);
			})
			.catch((e) => {
				if (!cancelled) setError(e instanceof Error ? e : new Error(String(e)));
			});
		return () => {
			cancelled = true;
		};
	}, [sources.join('|')]);

	return { ready, error };
};
